const trustHighlights = [
  { icon: "ri-shield-check-fill", label: "SOC 2 Type II Certified", desc: "Enterprise-grade security infrastructure" },
  { icon: "ri-scales-3-line", label: "TCPA-Aware Calling Logic", desc: "Built with compliance at the core" },
  { icon: "ri-lock-2-line", label: "Secure by Default", desc: "Encryption and data protection built in" },
  { icon: "ri-home-gear-line", label: "Built for Title Workflows", desc: "Not a generic tool repurposed for title" },
  { icon: "ri-flashlight-line", label: "Real Transaction Triggers", desc: "Live MLS and pending activity feeds" },
];

export default function WebinarTrustSection() {
  return (
    <section id="demo" className="bg-navy py-14 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-award-line text-primary text-xs" />
            <span className="text-xs font-semibold text-white">Built for Regulated Industries</span>
          </div>
          <h2
            className="text-white font-bold mb-4"
            style={{ fontSize: "clamp(26px, 3vw, 38px)", lineHeight: "1.2" }}
          >
            Built for Regulated Industries. Designed for Real Revenue Impact.
          </h2>
          <p className="text-white/60 text-base leading-relaxed">
            Imperium isn&apos;t a generic AI calling tool. It was built from the ground up for the title industry — with compliance, security, and transaction timing at its core.
          </p>
        </div>

        {/* Trust highlights */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8 md:mb-14">
          {trustHighlights.map((item) => (
            <div key={item.label} className="bg-white/5 border border-white/10 rounded-2xl px-5 py-6 flex flex-col items-center text-center gap-3 hover:bg-white/10 transition-colors">
              <div className="w-11 h-11 rounded-xl bg-primary/20 flex items-center justify-center">
                <i className={`${item.icon} text-primary text-lg`} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm mb-1">{item.label}</p>
                <p className="text-white/50 text-xs leading-snug">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonial / Quote */}
        <div className="max-w-2xl mx-auto rounded-2xl bg-white/5 border border-white/10 px-5 md:px-8 py-5 md:py-8 text-center">
          <div className="flex justify-center mb-4">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-primary text-sm" />
              </span>
            ))}
          </div>
          <blockquote className="text-white/90 text-lg font-medium leading-relaxed mb-6" style={{ lineHeight: "1.65" }}>
            &ldquo;This is exactly how my best rep talks — and it&apos;s happening automatically.&rdquo;
          </blockquote>
          <div className="flex items-center justify-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-secondary to-blue-300 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              TM
            </div>
            <div className="text-left">
              <p className="text-white font-semibold text-sm">Title Agency Principal</p>
              <p className="text-white/40 text-xs">Southeast Region · 3 offices</p>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-8 md:mt-14">
          {[
            { stat: "68,000+", label: "New listings triggered this week alone" },
            { stat: "9,714", label: "Listings ready to be triggered right now" },
            { stat: "15–20", label: "Closings needed per month to cover cost" },
          ].map((item) => (
            <div key={item.stat} className="text-center">
              <p className="text-white font-extrabold mb-2" style={{ fontSize: "clamp(32px, 3.5vw, 48px)", lineHeight: "1" }}>
                {item.stat}
              </p>
              <p className="text-white/50 text-sm leading-snug">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
